<template>
  <div class="active-list-wtxh scroll-box" @scroll="scrollBox($event)">
    <TopBarWtxh />
    <!-- 新闻网格 -->
    <div class="grid-wrap">
      <ul class="news-grid" v-if="list.length">
        <li
          class="news-card"
          v-for="item in list"
          :key="item.id"
          @click="toActiveInfo(item)"
        >
          <div class="card-cover">
            <img v-lazy="item.image" :key="item.image" />
          </div>
          <div class="card-info">
            <p class="card-name">{{ item.name }}</p>
            <div class="card-meta">
              <img class="meta-icon" src="@/assets/clock-grey-ico.png" />
              <span class="meta-text">{{ item.created_at }}</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="nodata" v-if="loaded && list.length === 0">
        <img class="nodata-img" :src="require('@/assets/no-data.png')" />
        <p class="nodata-text">暂无内容</p>
      </div>
    </div>
    <BottomWtxhM />
  </div>
</template>

<script>
import TopBarWtxh from "@/m/common/topBarWtxh.vue";
import BottomWtxhM from "@/m/common/bottomWtxhM.vue";

export default {
  name: "ActiveListWtxh",
  components: {
    TopBarWtxh,
    BottomWtxhM,
  },
  data() {
    return {
      moduleId: "",
      pageName: "",
      list: [],
      num: 0,
      limit: 10,
      nowPage: 1,
      more: false,
      loaded: false,
    };
  },
  mounted() {
    this.moduleId = this.$route.params.id;
    this.pageName = this.$route.params.name;
    this.getList();
  },
  methods: {
    getList() {
      this.$axios
        .post(`/v1/article/list`, {
          page: this.nowPage,
          pre_page: this.limit,
          module_id: this.moduleId,
        })
        .then((res) => {
          this.list.push(...res.data.data);
          this.num = res.data.total;
          this.more = this.list.length < this.num;
          this.loaded = true;
        });
    },
    toActiveInfo(data) {
      if (data.type === 0) {
        this.$router.push("/activeInfo/" + data.data_id);
      } else if (data.type === 1) {
        location.href = data.pc_link;
      }
    },
    scrollBox(e) {
      if (
        e.target.scrollHeight - e.target.clientHeight <= e.target.scrollTop + 2 &&
        this.more
      ) {
        this.nowPage++;
        this.getList();
      }
    },
  },
  watch: {
    $route(to) {
      this.moduleId = to.params.id;
      this.pageName = to.params.name;
      this.list = [];
      this.nowPage = 1;
      this.more = false;
      this.loaded = false;
      this.getList();
    },
  },
};
</script>

<style scoped lang="scss">
.active-list-wtxh {
  background-color: rgba(247, 251, 252, 1);
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.grid-wrap {
  padding: 20px 32px 40px;
  flex: 1;
}
.news-grid {
  display: flex;
  flex-wrap: wrap;
  column-gap: 26px;
  row-gap: 28px;
}
.news-card {
  width: 330px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 6px 0px rgba(219, 219, 219, 0.5);
  overflow: hidden;
}
.card-cover {
  width: 330px;
  height: 200px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
}
.card-info {
  padding: 20px;
}
.card-name {
  font-size: 28px;
  font-family: PingFangSC-Medium, "PingFang SC", sans-serif;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-meta {
  display: flex;
  align-items: center;
  margin-top: 16px;
}
.meta-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.meta-text {
  margin-left: 10px;
  font-size: 24px;
  font-family: PingFangSC-Regular, "PingFang SC", sans-serif;
  color: rgba(153, 153, 153, 1);
  line-height: 34px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nodata {
  width: 574px;
  padding-top: 20px;
  margin: 0 auto;
  text-align: center;
  .nodata-img {
    width: 100%;
    height: auto;
  }
  .nodata-text {
    font-size: 26px;
    color: #999;
    padding-top: 40px;
  }
}
</style>
